// extracted by mini-css-extract-plugin
export var actionButton = "_jg-t";
export var buttonContainer = "_jg-0";
export var buttonContainer2 = "_jg-1";
export var buttonSection = "_jg-2";
export var details = "_jg-3";
export var dropdownItem = "_jg-5";
export var dropdownItemsContainer = "_jg-4";
export var fileInput = "_jg-r";
export var headerButton = "_jg-6";
export var icon = "_jg-7";
export var input = "_jg-8";
export var macroListItem = "_jg-9";
export var mainContent = "_jg-a";
export var microText = "_jg-b";
export var modal = "_jg-w";
export var optionsButton = "_jg-c";
export var paperclip = "_jg-s";
export var pillContent = "_jg-d";
export var preview = "_jg-e";
export var preview2 = "_jg-f";
export var quillEditor = "_jg-q";
export var selectedMacro = "_jg-g";
export var sidebar = "_jg-h";
export var sidebarHeader = "_jg-j";
export var sidebarList = "_jg-i";
export var sidebarListItem = "_jg-k";
export var sidebarSearch = "_jg-l";
export var snoozeDurationWrapper = "_jg-v";
export var statusPillContainer = "_jg-m";
export var tagsContainer = "_jg-n";
export var unselectedMacro = "_jg-o";
export var variable = "_jg-u";
export var wrapper = "_jg-p";